<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="pl-md-10 col-10 col-md-10">
      <h2 class="my-0 py-0">Exam Result</h2>
    </div>
    <div class="col-2 col-md-2 align-self-center">
      <i class="fa fa-times close cursor-pointer" @click="closebutton"></i>
    </div>
  </div>
  <div class="wrapper wrapper-content">
    <div class="ibox-content">
      <div class="form-group row mb-3">
        <div class="col-12 col-md-5 my-1 pr-md-1">
          <div class="form-group mb-md-0 pr-md-1">
            <label class="mb-0">Name</label>
            <input
              type="text"
              class="form-control my-md-0"
              v-model="searchField.name"
            />
          </div>
        </div>
        <div class="col-12 col-md-5 my-1 pr-md-1">
          <div class="form-group mb-md-0">
            <label class="mb-0">Result</label>
            <select
              class="form-control my-md-0"
              name="account"
              placeholder="Search"
              v-model="searchField.result"
            >
              <option value="Passed">Passed</option>
              <option value="Failed">Failed</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-md-2 align-self-end my-1">
          <span
            type="button"
            class="submit_btn px-5 w-100"
            @click="OnSearchButtonClicked"
            >Search</span
          >
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-striped table-bordered dataTables">
          <thead>
            <tr>
              <th
                class="sort_block"
                @click="SortSelected('userName', 1)"
                id="1"
              >
                <div class="d-flex flex-row justify-content-between">
                  Name
                  <span>
                    <i class="fa fa-long-arrow-up"></i>
                    <i class="fa fa-long-arrow-down"></i>
                  </span>
                </div>
              </th>

              <th
                class="sort_block"
                @click="SortSelected('questionNumber', 2)"
                id="2"
              >
                <div class="d-flex flex-row justify-content-between">
                  Total Questions
                  <span>
                    <i class="fa fa-long-arrow-up"></i>
                    <i class="fa fa-long-arrow-down"></i>
                  </span>
                </div>
              </th>
              <th
                class="sort_block"
                @click="SortSelected('configPercentage', 3)"
                id="3"
              >
                <div class="d-flex flex-row justify-content-between">
                  Pass Grade
                  <span>
                    <i class="fa fa-long-arrow-up"></i>
                    <i class="fa fa-long-arrow-down"></i>
                  </span>
                </div>
              </th>
              <th class="sort_block" @click="SortSelected('mark', 4)" id="4">
                <div class="d-flex flex-row justify-content-between">
                  Score
                  <span>
                    <i class="fa fa-long-arrow-up"></i>
                    <i class="fa fa-long-arrow-down"></i>
                  </span>
                </div>
              </th>

              <th class="sort_block" @click="SortSelected('result', 5)" id="5">
                <div class="d-flex flex-row justify-content-between">
                  Result
                  <span>
                    <i class="fa fa-long-arrow-up"></i>
                    <i class="fa fa-long-arrow-down"></i>
                  </span>
                </div>
              </th>
              <th
                class="sort_block"
                @click="SortSelected('examDate', 6)"
                id="6"
              >
                <div class="d-flex flex-row justify-content-between">
                  Exam Date
                  <span>
                    <i class="fa fa-long-arrow-up"></i>
                    <i class="fa fa-long-arrow-down"></i>
                  </span>
                </div>
              </th>
              <th class="text-center">View Answer</th>
              <th class="text-center">Review</th>
              <th class="text-center">Approve Result</th>
              <th class="text-center">Retest</th>
              <th class="text-center">Report</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="mark in markList" :key="mark.Id">
              <td>
                {{ mark.userName }}
              </td>
              <td>{{ mark.questionNumber }}</td>
              <td>{{ mark.configPercentage }}</td>
              <td>{{ mark.mark }}</td>
              <td>{{ mark.result }}</td>
              <td>{{ mark.examDate.slice(0, 10) }}</td>
              <!-- createdAt -->
              <td class="text-center">
                <a @click.prevent="view(mark.userExamId, mark.approvedStatus)"
                  ><i class="fa fa-eye edit-delete"></i>
                </a>
              </td>

              <td class="text-center">
                <a
                  href="#"
                  class="mb-1"
                  data-toggle="modal"
                  data-target="#assignUser1"
                  ><img
                    src="../../assets/img/assign_user.png"
                    alt="approval_status"
                    @click="AssignedUser(mark.userExamId)"
                /></a>
              </td>
              <td class="text-center">
                <a
                  href="#"
                  class="mb-1"
                  data-toggle="modal"
                  data-target="#assignUser1"
                  ><img
                    v-if="
                      mark.approvedStatus == 'Pending' ||
                      mark.approvedStatus == null
                    "
                    src="../../assets/img/approve_test.png"
                    alt="Delete"
                    @click="approve(mark.userExamId)"
                  />
                </a>
                <span
                  v-if="
                    mark.approvedStatus == 'Approved' ||
                    mark.approvedStatus == 'Rejected'
                  "
                >
                  {{ mark.approvedStatus }}
                </span>
              </td>
              <td class="text-center">
                <a
                  v-if="
                    mark.result == 'Failed' || mark.approvedStatus == 'Rejected'
                  "
                  href="#"
                  class="mb-1"
                  data-toggle="modal"
                  data-target="#assignUser1"
                  ><img
                    src="../../assets/img/retest.png"
                    alt="Delete"
                    @click="ReTest(mark.CreatedUserEmail, mark.userExamId)"
                  />
                </a>
              </td>
              <td class="text-center">
                <a
                  href="#"
                  class="mb-1"
                  data-toggle="modal"
                  data-target="#assignUser1"
                >
                  <img
                    src="../../assets/img/testretest.png"
                    alt="Delete"
                    @click="ReportGenerate(mark.userExamId)"
                  />
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-12 d-flex justify-content-md-end px-0">
        <v-pagination
          v-model="currentPage"
          :pages="totalPage"
          :range-size="1"
          active-color="#ededed"
          @update:modelValue="loadPage"
        />
      </div>
    </div>
  </div>
  <div v-if="showApprove" class="modal__wrapperexam">
    <div class="modal__approver__container">
      <div
        class="modal-header-projects d-flex justify-content-between py-2 px-3"
      >
        <h4 class="my-0">Approve Result</h4>
        <div class="cursor-pointer" @click.prevent="ClosefolderModal()">
          <i class="fa fa-times"></i>
        </div>
      </div>
      <div class="modal-body">
        <div class="chat-form border-bottom">
          <form role="form">
            <div class="form-group">
              <textarea
                class="form-control"
                placeholder="Message"
                v-model="comments"
              ></textarea>
            </div>
            <div class="text-right mb-2">
              <button
                type="button"
                class="btn btn-primary btn-xs px-4 mr-3"
                @click="ApprovalStatus('Approved')"
              >
                Approve
              </button>
              <button
                type="button"
                class="btn btn-danger btn-xs px-4 float-right"
                @click="ApprovalStatus('Rejected')"
              >
                Reject
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div v-if="showReport" class="modal__wrapperexam">
    <div class="modal__approver__container">
      <div
        class="modal-header-projects d-flex justify-content-between py-2 px-3"
      >
        <h4 class="my-0">Download Document</h4>
        <div class="cursor-pointer" @click.prevent="Closedownload()">
          <i class="fa fa-times"></i>
        </div>
      </div>
      <div class="modal-body">
        <div class="chat-form border-bottom">
          <form role="form">
            <div class="form-group">
              <h5>!!! Digital signatures are legally binding !!!</h5>
              <input
                type="password"
                class="form-control"
                placeholder="Digi sign password"
                v-model="password"
              />
            </div>
            <div class="text-right mb-2">
              <button
                type="button"
                class="btn btn-primary btn-xs px-4 mr-3"
                @click="DownloadReport2()"
              >
                Download
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <Exam_Approver
    v-if="showAddApprove"
    :documentId="documentid"
    :userExamId="examId"
    :projectId="projectid"
    :dropdownName="dropdownname"
    @closeApproveModal="showAddApprove = false"
  >
  </Exam_Approver>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import Exam_Approver from "../Exam_Approver/Exam_Approver.vue";
import { file } from "@babel/types";

export default {
  props: {
    documentid: String,
  },
  components: {
    Exam_Approver,
  },
  data() {
    return {
      baseurl: `${process.env.VUE_APP_Service_URL}document/documentquestion/`,
      userUrl: `${process.env.VUE_APP_Service_URL}account-core/user/`,
      idtoken: "",
      showDesig: false,
      markList: "",
      showApprove: false,
      showAddApprove: false,
      showReport: false,
      newUserExamId: "",
      password: "",
      setpreviouspath: "",
      examId: "",
      comments: "",
      userList: [],
      searchField: {
        name: "",
        result: "",
      },
      currentPage: 1,
      pageindex: 1,
      pagesize: 10,
      totalPage: 1,
      SortProperty: "",
      SortOrder: false,
      SortOrderInt: 0,
      prevRoute: null,
      sourcePage: "",
      sourceRoute: "",
      designationPrivileges: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  async mounted() {
    store.dispatch("setdocumenttodepartment", true);
    this.sourcePage = await store.getters.getDocViewSource;
    this.designationPrivileges = store.getters.getRolesprivilegeData;
    this.sourcePage = await store.getters.getDocViewSource;
        if (this.sourcePage == `Project` || this.sourcePage == 'ProjectSummary') {
          this.sourceRoute = `Projects`;
        } else if (this.sourcePage == `Department`) {
          this.sourceRoute = `Departments`;
        }
        if(this.designationPrivileges.includes(this.sourceRoute+` Configure Exam`)){
        }
        else{
            this.$router.push(`/noprivilege`);
        }

    console.log("this.sourcePage", this.sourcePage);
    if (this.prevRoute != null) {
      if (this.prevRoute.path != "/") {
        localStorage.setItem("patvalue", this.prevRoute.path);
      }
      this.setpreviouspath = localStorage.getItem("patvalue");
      console.log("path", this.prevRoute.path);
    }
    this.Head = {
      headers: {
        Authorization: "Bearer " + store.getters.getToken,
        "Content-Type": "application/json",
      },
    };
    this.idtoken = store.getters.getToken;
    this.ListUsers();
  },

  methods: {
    async OnSearchButtonClicked() {
      this.pageindex = 1;
      this.currentPage = 1;
      this.ListUsers();
    },
    ReportGenerate(id) {
      this.password = "";
      this.showReport = true;
      this.examId = id;
    },

    approve(id) {
      this.showApprove = true;
      this.newUserExamId = id;
    },
    CloseApproverModal() {
      this.showAddApprove = false;
    },
    AssignedUser(id) {
      this.showAddApprove = true;
      this.examId = id;
    },
    async DownloadReport2() {
      
      try {
        const response = await fetch(
          `https://dmsdev.datamatica.uk/v1/document/documentquestion/resultpdf?examId=${this.examId}&password=${this.password}`,
          {
            headers: {
              Authorization: "Bearer " + this.idtoken,
            },
          }
        );

        var x = response.headers.get("Content-Disposition");
        var xx = x.split("filename=")[1];
        const blob = await response.blob();
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        let filename = xx.split(";")[0];
        const name = filename.replace(/"/g, '');
        link.setAttribute("download",name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        this.showReport = false;
      } catch {
        alert("Please enter correct credentials.");
      }
    },

    async ApprovalStatus(value) {
      if (value == "Approved") {
        if (confirm("Are you sure you want to approve the test result?")) {
          await this.approveOrReject(value);
        }
      } else {
        if (confirm("Are you sure you want to reject the test result?")) {
          await this.approveOrReject(value);
        }
      }
    },
    async ReTest(email, userexamid) {
      if (confirm("Are you sure you want to request retest?")) {
        await axios
          .post(
            `${this.baseurl}retestnotification`,
            {
              documentId: this.documentid,
              userEmail: email,
              userexamid: userexamid,
            },
            this.Head
          )
          .then((res) => {
            this.disignations = res.data.entities;
            alert("Re-test requested successfully")
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    ClosefolderModal() {
      this.showApprove = false;
    },
    async ListApproverUsers() {
      await axios
        .get(`${this.userUrl}getlist`, this.Head)
        .then((res) => {
          this.userList = res.data.entities;
        })
        .catch((err) => {
          console.log(err);
          this.userList = [];
          alert("No data found!");
        });
    },
    Closedownload() {
      this.showReport = false;
    },
    async closebutton() {
      this.$router.push(`/documentview/` + this.documentid + "/" + 0 )
      // let selectfolder = store.getters.getselectedFolder;
      // store.dispatch("setopenfolder", selectfolder);
      // store.dispatch("selectedfolder", selectfolder);
      // if (this.setpreviouspath.includes("project_summary")) {
      //   let path = localStorage.getItem("patvalue");
      //   this.$router.push(path);
      // } else if (this.setpreviouspath == "/department") {
      //   this.$router.push(`/department`);
      // } else if (this.setpreviouspath.includes("myQuestion")) {
      //   this.$router.push(`/department`);
      // }
    },
    async approveOrReject(approvalStatus) {
      await axios
        .put(
          `${this.baseurl}approvereject`,
          {
            userExamId: this.newUserExamId,
            approvalStatus: approvalStatus,
            comments: this.comments,
          },
          this.Head
        )
        .then((res) => {
          this.disignations = res.data.entities;
          this.showApprove = false;
          this.comments = "";
          this.ListUsers();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async view(id, approvalstate) {
      store.dispatch("setprvspath","/ExamResult/"+this.documentid)
      store.dispatch("setTestApprovalstatus", approvalstate);
      this.$router.push("/myQuestion/" + this.documentid + "/" + id);
    },
    async ListUsers() {
      await axios
        .get(
          `${this.baseurl}gettestresult?documentid=${this.documentid}&username=${this.searchField.name}&examresult=${this.searchField.result}&PageIndex=${this.pageindex}&PageSize=${this.pagesize}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrderInt}`,
          this.Head
        )
        .then((res) => {
          this.markList = res.data.entities;
          this.totalPage = parseInt(res.data.totalCount / this.pagesize);
          if (res.data.totalCount % this.pagesize != 0) {
            this.totalPage = this.totalPage + 1;
          }
          if (res.data.totalCount == 0) {
            alert("No data found!");
          }
        })
        .catch((err) => {
          console.log(err);
          this.markList = [];
          alert("No data found!");
        });
    },
    SortSelected(sortProp, id) {
      console.log("SortPropChanged", sortProp, id);
      const selectedElement = document.getElementById(id);
      const selectedElementID = document.getElementById(id).id;
      if (sortProp != null && id == selectedElementID) {
        this.sortDesc = !this.sortDesc;
        if (this.SortOrder == 0) {
          if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc");
            selectedElement.classList.add("sortDesc");
          } else selectedElement.classList.add("sortDesc");
        } else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc");
            selectedElement.classList.add("sortAsc");
          } else selectedElement.classList.add("sortAsc");
        }
      }
      this.pageindex = 1;
      this.currentPage = 1;
      this.SortProperty = sortProp;
      this.SortOrder = this.SortOrder == true ? false : true;
      this.SortOrderInt = this.SortOrder == true ? 0 : 1;
      this.ListUsers();
    },
    loadPage: function (page) {
      this.currentPage = page;
      this.pageindex = page;
      this.ListUsers();
    },
  },
};
</script>

<style scoped>
@import "./modal.css";
.submit_btn {
  text-align: center;
  cursor: pointer;
  background-color: #7b8cea !important;
  color: rgb(255, 255, 255) !important;
  padding: 0.55rem 0.4rem;
  border-radius: 0.25rem;
  border-color: #7b8cea !important;
  transition: background-color 0.3s ease-in-out 0s !important;
}
.modal-header-projects {
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}
.modal__wrapperexam {
  position: fixed;
  background: rgb(0 0 0 / 18%);
  height: 100%;
  width: 100%;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: cubic-bezier;
  overflow: hidden;
}
.modal__approver__container {
  width: min(38%, 80%);
  position: fixed;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  overflow-x: hidden;
}
.previousbtn,
.nextbtn {
  margin: 0;
  border-radius: 0px;
  border: 0.5px solid #eeeeee;
}
.page-links {
  border-radius: 0px;
}
/*pagination styles*/
.pagination {
  margin: 0;
}
.Page,
.PaginationControl {
  border: 1px solid #e7eaec;
}
.Page-active {
  padding: 1rem;
  border: 1px solid var(--pagination-active-clr);
  border-radius: inherit;
  margin: 0;
}
.Page {
  padding: 1rem;
  border-radius: inherit;
  margin: 0;
}
.PaginationControl {
  padding: 0.42rem;
}
.create-block {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.25rem;
}
.position-relative img {
  width: 20px;
}
.cursor-pointer {
  cursor: pointer;
}
.position-relative .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.3rem 0.8rem;
  right: 0;
  top: -30px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}
.position-relative:hover .tool-tip,
.position-relative:focus-visible .tool-tip {
  visibility: visible;
  -webkit-transition: visibility 30ms ease-in;
  transition: visibility 30ms ease-in;
}
.headingunderline {
  text-decoration-line: underline;
}

.create-folder-modal {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}
.folder-modal-container {
  background: #fff;
  width: min(40%, 90%);
  border-radius: 4px;
  position: fixed;
  overflow-x: hidden;
  pointer-events: auto;
}
.title-class1 {
  background-color: #618bd7;
  color: #fff;
}
.errorClass {
  color: red;
  font-size: 13px;
}
.button-class {
  float: right;
}
</style>
